export const MESSAGE_POSITION =  { position: "absolute", top: "calc(100vh - 135px)", right: 5 };
export const TOOLTIP_DELAY = 1.5;
export const TOOLTIP_DELAY_FOR_ICON = 0.3;
